<template>
    <div class="hero-container flex flex-col md:flex-row items-center md:items-start position-relative md:mb-3 rounded-xl p-4"
         :class="{'hero-minimized-content': isMinimized}">
        <div class="backdrop"
            :style="{ 'background-image': 'linear-gradient(to bottom, transparent, black),'+ backgroundImage }"
            :class="{'backdrop-minimized': isMinimized}">
        </div>
        <!-- 使用单一容器，通过CSS控制布局变化 -->
        <div class="hero-content-wrapper" :class="{'minimized-layout': isMinimized}">
            <img v-if="image" :src="image" class="rounded-xl hero-image" 
                 :class="{'image-minimized': isMinimized}">
            <img v-else src="/static/dist/img/album_null.jpg" class="rounded-xl hero-image" 
                 :class="{'image-minimized': isMinimized}">
            <div class="body pt-4 pt-md-0 pl-md-4" :class="{'body-minimized': isMinimized}">
                <slot/>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            image: {type: String, default: null},
            isMinimized: {type: Boolean, default: false},
        },
        computed: {
            backgroundImage() {
                return `url('${this.image || '/static/dist/img/album_null.jpg'}')`
            }
        },
    }
</script>
<style scoped>
/* 主容器样式 */
.hero-container {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* 内容包装器 */
.hero-content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* 桌面端内容包装器 */
@media (min-width: 768px) {
    .hero-content-wrapper {
        flex-direction: row;
        align-items: flex-start;
    }
}

.hero-image {
    display: block;
    width: 250px;
    height: auto;
    max-width: 75%;
    aspect-ratio: 1;
    object-fit: cover;
    z-index: 2;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform-origin: center;
}

.image-minimized {
    width: 120px;
    max-width: 35%;
}

.backdrop {
    position: absolute;
    z-index: 1;
    width: 81%;
    top: 3%;
    height: calc(250px);
    transform: scale(1.025);
    filter: blur(8px);
    opacity: 0.25;
    background-size: max(100%, 1000px) auto;
    background-position: center center;
    background-repeat: no-repeat;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.backdrop-minimized {
    height: calc(120px);
    opacity: 0;
    transform: scale(0.8);
}

.hero-minimized-content {
    padding: 1rem !important;
}

.minimized-layout {
    flex-direction: row !important;
    align-items: flex-start !important;
}

.body {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.body-minimized {
    padding-top: 0 !important;
    padding-left: 1rem !important;
    flex: 1;
}

/* 移动端专用样式 */
@media (max-width: 767px) {
    .hero-content-wrapper {
        flex-direction: column;
        align-items: center;
    }
    
    .minimized-layout {
        flex-direction: row !important;
        align-items: flex-start !important;
    }
    
    .image-minimized {
        width: 60px;
        max-width: 60px;
        min-width: 60px;
        flex-shrink: 0;
        transform: scale(1);
    }
    
    .backdrop-minimized {
        height: calc(60px);
        opacity: 0;
        transform: scale(0.6);
    }
    
    .hero-minimized-content {
        padding: 0.75rem !important;
    }
    
    .body-minimized {
        padding-top: 0 !important;
        padding-left: 0.75rem !important;
        flex: 1;
    }
}

/* 桌面端不应用缩小效果 */
@media (min-width: 768px) {
    .image-minimized {
        width: 250px;
        max-width: 75%;
    }
    
    .backdrop-minimized {
        height: calc(250px);
        opacity: 0.25;
    }
    
    .hero-minimized-content {
        padding: 1rem !important;
    }
}
</style>
